import React, { useState, useEffect, useRef } from 'react';

import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { InputTextarea } from 'primereact/inputtextarea';
import { InputMask } from 'primereact/inputmask';

import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

import { useTranslation } from 'react-i18next';


import { Toolbar } from 'primereact/toolbar';
import { Dialog } from 'primereact/dialog';
import EventBus from "../../common/EventBus";
import { Toast } from 'primereact/toast';
import AuthService from '../../security/AuthService';
import PhoneInput from 'react-phone-number-input'
import 'react-phone-number-input/style.css'
import AccountService from '../../service/AccountService';
import utils from '../../constants/utils';
import ResourceService from '../../service/ResourceService';
import { Editor } from 'primereact/editor';
export const Resource = (props) => {


    const { t } = useTranslation();
    const toast = useRef(null);
    const [displayLoadingDialog, setDisplayLoadingDialog] = useState(false);

    const [resourceGroups, setResourceGroups] = useState([]);

    const [selectedResourceGroups, setSelectedResourceGroups] = useState(null);

    const [existResourceItems, setExistResourceItems] = useState([]);
    const [resourceItems, setResourceItems] = useState([]);



    useEffect(() => {
        onLoadData();
    }, []);


    const onLoadData = () => {
        setDisplayLoadingDialog(true);

        ResourceService.inquireResourceGroup().then(
            (response) => {

                console.log("inquireResourceGroup", response.data.data.dataList)
                if (response.data.data.dataList.length > 0) {
                    console.log("set inquireResourceGroup", response.data.data.dataList)
                    setResourceGroups(response.data.data.dataList);
                }
                setDisplayLoadingDialog(false);
            },
            (error) => {
                setDisplayLoadingDialog(false);

                const _content =
                    (error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                    error.message ||
                    error.toString();

                console.log(_content);

                if (error?.response?.status === 403 || error?.Error?.includes("403")) {

                    console.log("inquireResourceGroup logout******")
                    EventBus.dispatch("logout", props);
                } else {
                    toast.current.show({ severity: 'error', summary: t("global_error") + error?.response?.status, detail: t("global_error_detail"), life: 5000 });
                }
            }
        );


    }

    const onLoadDataByGroup = (groupName) => {
        setDisplayLoadingDialog(true);

        ResourceService.inquireResourcesbyGroup(groupName).then(
            (response) => {

                console.log("inquireResourcesbyGroup", response.data.data.dataList)
                if (response.data.data.dataList.length > 0) {
                    console.log("set inquireResourcesbyGroup", response.data.data.dataList)
                    setResourceItems(response.data.data.dataList);
                    setExistResourceItems(JSON.parse(JSON.stringify(response.data.data.dataList)));

                }
                setDisplayLoadingDialog(false);
            },
            (error) => {
                setDisplayLoadingDialog(false);

                const _content =
                    (error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                    error.message ||
                    error.toString();

                console.log(_content);

                if (error?.response?.status === 403 || error?.Error?.includes("403")) {

                    console.log("inquireResourcesbyGroup logout******")
                    EventBus.dispatch("logout", props);
                } else {
                    toast.current.show({ severity: 'error', summary: t("global_error") + error?.response?.status, detail: t("global_error_detail"), life: 5000 });
                }
            }
        );


    }


    const onSelectGroup = (param) => {
        console.log("onSelectGroup", param.groupName);
        setSelectedResourceGroups(param);
        onLoadDataByGroup(param.groupName);
    }

    const update = () => {
        console.log("update");
        let _changedResource = [];
        existResourceItems.map((item, index) => {
            console.log("existResourceItems", item, resourceItems[index].value);
            if (item.value != resourceItems[index].value) {
                console.log("existResourceItems farklı", item.value, resourceItems[index].value);
                _changedResource.push(resourceItems[index]);
            } else {

            }
        })



        if (_changedResource.length > 0) {

            let apiParams = selectedResourceGroups;
            apiParams.resourceItems = _changedResource;
            console.log("update _group", apiParams);



            ResourceService.updateResource(apiParams).then(
                (response) => {
                    console.log("updateResource", response)
                    onLoadDataByGroup(selectedResourceGroups.groupName);
                },
                (error) => {
                    const _content =
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        error.toString();

                    console.log(_content);

                    if (error?.response?.status === 403 || error?.Error?.includes("403")) {
                        EventBus.dispatch("logout", props);

                    } else {
                        toast.current.show({ severity: 'error', summary: t("global_error") + error?.response?.status, detail: t("global_error_detail"), life: 5000 });
                    }
                }
            );
        } else {
            console.log("Select Waitlist");
        }

    }

    const updateValue = (name, param) => {
        console.log("updateValue", name, param);
        let _resourceItems = [];
        resourceItems.map((item, index) => {
            if (item.name === name) {

                item["value"] = param;
                console.log("item change ***************", item, param);
                _resourceItems.push(item);
            } else {
                _resourceItems.push(item);
            }

        }
        )
        setResourceItems(_resourceItems);
    }

    const getKeyFilter = (param) => {
        let _keyfilter = "alphanum";
        if (param.resourceType === "Long") {
            _keyfilter = "int";
        } else if (param.resourceType === "String") {
            _keyfilter = "";
        } else if (param.resourceType === "Bigdecimal") {
            _keyfilter = "num";
        } else if (param.resourceType === "Boolean") {
            _keyfilter = "alphanum";
        } else if (param.resourceType === "JSON") {
            _keyfilter = "alphanum";
        } else if (param.resourceType === "BigDecimal") {
            _keyfilter = "num";
        } else if (param.resourceType === "Timestamp") {
            _keyfilter = "timestamp";
        }else if (param.resourceType === "RichText") {
            _keyfilter = "richtext";
        }

        console.log("_keyfilter", _keyfilter, param.resourceType)

        if (_keyfilter === "timestamp") {
            return <InputTextarea keyfilter={_keyfilter} autoResize id={param.name} value={param.value} onChange={(e) => { updateValue(param.name, e.target.value) }} type="text"
                className="w-full inputtext_raunded p-inputtext "
            />
        } else if (_keyfilter === "richtext") {
            return  <Editor id={param.name} value={param.value} onTextChange={(e) => { updateValue(param.name, e.htmlValue) } } style={{ height: '320px' }} editorStyle={{height: '320px'}} />
        } else {
            return <InputTextarea keyfilter={_keyfilter} autoResize id={param.name} value={param.value} onChange={(e) => { updateValue(param.name, e.target.value) }} type="text"
                className="w-full inputtext_raunded p-inputtext "
            />
        }

    }




    const renderResources = () => {
        return (
            <div className="grid flex  " >
                {resourceItems.map((param, index) => {

                    console.log("resourceItems.map", param);

                    return (
                        <div className="col-12 ">
                            <div className="grid " >
                                <div className="col-4 ">
                                    {t(param.name)}
                                </div>
                                <div className="col-8 ">
                                    {
                                        getKeyFilter(param)
                                    }

                                </div>
                            </div>
                        </div>
                    )
                })
                }
            </div>
        )
    }
    const optionTemplate = (option) => {
        return (
            <div className="flex align-items-center">
                <div>{t(option.groupName)}</div>
            </div>
        );
    };
    const selectedTemplate = (option, props) => {
        if (option) {
            return (
                <div className="flex align-items-center">
                <div>{t(option.groupName)}</div>
                </div>
            );
        }

        return <span>{props.placeholder}</span>;
    };


    return (
        <div className="layout-dashboard">
            <Toast ref={toast} />
            <div className="grid flex  " >


                <div className="col-12 ">

                    <Dropdown id="resource_group" value={selectedResourceGroups} onChange={(e) => onSelectGroup(e.value)} options={resourceGroups} optionLabel="groupName"
                        placeholder={t('global_text_selectone')} filter
                        className="inputtext_raunded mb-5" 
                        itemTemplate={optionTemplate} valueTemplate={selectedTemplate}
                        />



                </div>
                <div className="col-12 ">
                    {renderResources()}
                </div>
                <div className="col-12 ">
                    <Button label={t("global_btn_update")} className="p-button-rounded mr-2 mb-2 mt-2"
                        onClick={() => update()}
                    />
                </div>

            </div>
        </div>
    )
}